module.exports = "https://cdn.dove.it/_next/static/public/assets/happy-couple-house-2.95b02c3b662085b17164b3a860b770bd.jpg";